import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Navbar />

      <main>
        <HeroSection />
        <FaqSection />
        <IndexSection />
        <UpdatesSection />
        <ContactSection />
        <CardsSection />
        <FeaturesSection />
        <RankingSection />
        <AboutSection />
        <AppSection />
        <CarouselSection />
        <MediaSection />
        <CommentsSection />
        <TopicsSection />
      </main>

      <Footer />
    </div>
  );
}